import { CSSProperties } from "react";

import { cx, styled } from "simplydo/react/styled";

type PlaceholderImageProps = {
  square?: boolean;
  rectangular?: boolean;
  className?: string;
  style?: CSSProperties;
  size?: "full" | "large" | "medium" | "small";
};

const SIZES: Record<string, string> = {
  full: "100%",
  large: "256px",
  medium: "128px",
  small: "64px",
};

const ImageEl = styled.div<{ $size?: string }>`
  width: ${({ $size }) => $size || SIZES.small};
  aspect-ratio: 16 / 9;
  background: rgba(0, 0, 0, 0.06);
  border-radius: 0.2em;

  &.is-square {
    aspect-ratio: 1 / 1;
    height: ${({ $size }) => $size || SIZES.small};
  }
`;

const PlaceholderImageComponent = ({
  square,
  className,
  style,
  size,
}: PlaceholderImageProps) => {
  return (
    <ImageEl
      className={cx(square && "is-square", className)}
      style={style}
      $size={size && SIZES[size]}
    />
  );
};

export const PlaceholderImage = styled(PlaceholderImageComponent)``;
